import React, {useContext, useEffect, useState} from 'react'
import {MDBCol, MDBIcon, MDBInput, MDBRow} from "mdbreact";

import {useHistory} from "react-router-dom";
import {Button} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

import firebaseConnector from "../api/firebase-connector";

import ConfigContext from "../context/config.context";


export default function ResetPasswordPage(){
    const {config} = useContext(ConfigContext)
    const [images, setImages] = useState(["", "", ""])

    useEffect(() => {
        const prepare = async () => {

            const result = await Promise.all([
                firebaseConnector.storage().ref(`${config.loginLeftPanelImagePath}`).getDownloadURL(),
                firebaseConnector.storage().ref(`${config.loginRightPanelImagePath}`).getDownloadURL(),
                firebaseConnector.storage().ref(`${config.logoImagePath}`).getDownloadURL()
            ])

            setImages(result);

            console.log(result)
        }
        prepare()
    }, [])

    useEffect(() => {
        console.log(images)
    }, [images])

    const useStyles = makeStyles((theme) => ({
        root: {
            margin: 0,
            height: "100vh",
            justifyContent: "center"
        },
        leftPanel: {
            backgroundImage: `url(${images[0]})`,
            backgroundPosition : "center",
            alignItems: "center",
            display: "grid",
            backgroundSize: "cover",
            color : theme.palette.text.main
        },
        rightPanel: {
            display: "grid",
            alignItems: "center",
            textAlign: "center",
            backgroundColor: "#FFF",
            color : theme.palette.primary.main,
        },
        headerText:{
            fontWeight : "bold",
            width : "100%",
            textAlign : "center",
            fontSize : "2rem",
            color: theme.palette.primary.main
        },
    }));
    const classes = useStyles()

    return(
        <div>
            <MDBRow className={classes.root}>
                <MDBCol md="6" className={classes.leftPanel}>
                    <MDBRow center={true}>
                        <MDBCol size="7" style={{textAlign: "center", paddingBottom: "6rem"}}>
                            <img src={images[2]} alt={"logo"} style={{paddingBottom: "4rem"}}/>
                            <LoginForm/>
                        </MDBCol>
                    </MDBRow>
                </MDBCol>
                <MDBCol md="6" className={classes.rightPanel}>
                    <img src={images[1]} alt="login-svg" className="img-fluid"/>
                </MDBCol>
            </MDBRow>
        </div>
    );
}


const LoginForm = () => {
    const [email, setEmail] = useState("")
    const [error, setError] = useState("")
    const [isValidate, setIsValidate] = useState(false)

    const history = useHistory();

    const useStyles = makeStyles((theme) => ({
        inputContainer:{
            fontWeight: "normal",
            fontSize: "1rem",
            color: theme.palette.text.main,
            '& input':{
                color: theme.palette.text.main,
                borderBottom: `1px solid ${theme.palette.text.main}!important`,
            },
            '& label':{
                color: theme.palette.text.main,
            }
        },
        loginButton: {
            borderRadius : "25px",
            backgroundColor: theme.palette.primary.main,
            color: "white",
            "&.disabled":{
                backgroundColor: "rgba(0,0,0,0.118)"
            }
        }
    }));
    const classes = useStyles()

    const {config} = useContext(ConfigContext)

    useEffect(()=>{
        setIsValidate(email !== "")
    }, [email])

    const handleSubmit = async (event) =>{
        event.preventDefault()
        firebaseConnector.auth().sendPasswordResetEmail(email).then(function() {
            history.push(`/login`);
        }).catch(function(error) {
            setError(error)
        });
    }

    return(
        <form onSubmit={handleSubmit} style={{textAlign: "left"}}>
            <div className="signin">
                <h2 style={{textAlign: "center", fontWeight: "bold"}}>Réinitialiser le mot de passe</h2>
                <br/>

                <MDBInput
                    containerClass={classes.inputContainer}
                    focused
                    label="Adresse e-mail"
                    getValue={setEmail}
                    icon="envelope"
                    value={email}
                    iconLight={true}
                    type="email"
                />

                <div className="text-center" style={{marginTop: "2rem"}}>
                    <Button
                        variant="contained"
                        type="submit"
                        color="primary"
                        disabled={!isValidate}
                        className={classes.loginButton}
                        size="large"
                    >
                        Recevoir un mail
                    </Button>
                    {error && <p className="mt-1">{error.message}</p>}
                </div>
            </div>
        </form>
    );
}